var resizeTimer = null;

loadContent = function (sURL, sDivId) {
    loadContent(sURL, sDivId, true, false);
};

loadContent = function (sURL, sDivId, bShowOverlay, sOverlaySize, fnCallback, sOverlayTitle) {
    var bool_Return = false;

    if (bShowOverlay == undefined)
        bShowOverlay = true;

    if (sOverlaySize == undefined)
        sOverlaySize = "lg";

    bool_Return = loadHTML(sURL, sDivId, bShowOverlay, sOverlaySize, fnCallback, sOverlayTitle);

    return bool_Return;
};

loadHTML = function (sURL, sDivId, bShowOverlay, sOverlaySize, fnCallback, sOverlayTitle) {
    var objNow          = new Date();
    var randomh         = Math.random();
    var sPram           = (sURL.indexOf("?") > 0) ? "&t=" : "?x=";
    var sURL_To_Load    = sURL + sPram + randomh + "";

    if (bShowOverlay == undefined)
        bShowOverlay = true;

    if (sOverlaySize == undefined)
        sOverlaySize = "lg";

    $.ajax({
        url: sURL_To_Load,
        headers: {
            "X-Response-Type": "ajax"
        },
        success: function (xhmlContent, textStatus, XMLHttpRequest) {

            if (XMLHttpRequest.getResponseHeader("Content-Type").search(/text\/html/i) >= 0) {
                handleResponse(sDivId, xhmlContent, textStatus, XMLHttpRequest, bShowOverlay, sOverlaySize, sOverlayTitle, fnCallback);
            } else if ((fnCallback !== undefined) && (fnCallback !== null)) {
                fnCallback(xhmlContent, textStatus, XMLHttpRequest, sDivId, bShowOverlay);
            }
        },
        error: function (xhr, textStatus, error) {
            if ((fnCallback !== undefined) && (fnCallback !== null)) {
                //debugger;
                fnCallback(xhr.responseText, textStatus, XMLHttpRequest, sDivId, bShowOverlay);
            }
        }
    });

    return false;
};

loadLocalContent = function (sDivId, sContent, bShowOverlay, sOverlaySize, sOverlayTitle, fnCallback) {

    if (bShowOverlay == undefined)
        bShowOverlay = true;

    if (sOverlaySize == undefined)
        sOverlaySize = "lg";

    handleResponse(sDivId, sContent, null, null, bShowOverlay, sOverlaySize, sOverlayTitle, fnCallback);

    return false;
};

postContent = function (objForm, sDivId, bShowOverlay, sOverlaySize, fnCallback, sUrlOveride) {

    try {
        if (!$(objForm).valid()) {
            return false;
        }
    } catch (e) {
        console.log("Error validating form will leave it to the server")
    }

    //$(objForm).validate({
    //    invalidHandler: function (event, validator) {
    //        debugger;
    //    },
    //    submitHandler: function (objForm) {

    var sOverlayDivId = sDivId.replace('-content', '-holder');

    var form = $(objForm)[0];
    var sEncType = (($(objForm).attr("enctype") !== undefined) && ($(objForm).attr("enctype") !== "")) ? $(objForm).attr("enctype") : "application/x-www-form-urlencoded";
    var isMultipart = (sEncType === "multipart/form-data");
    var sData = "";
    var sURL_To_Load = objForm.action;
    var sContentType = false;

    if (isMultipart) {
        sContentType = false
        sData = new FormData(form);
    } else {
        sContentType = sEncType
        sData = $(objForm).serialize();
    }

    if (bShowOverlay == undefined)
        bShowOverlay = true;

    if ((sOverlaySize == undefined) || (sOverlaySize == "")) {
        if ($("#" + sOverlayDivId + " .modal-dialog").hasClass("modal-sm")) {
            sOverlaySize = "sm";
        } else if ($("#" + sOverlayDivId + " .modal-dialog").hasClass("modal-md")) {
            sOverlaySize = "md";
        } else if ($("#" + sOverlayDivId + " .modal-dialog").hasClass("modal-lg")) {
            sOverlaySize = "lg";
        } else if ($("#" + sOverlayDivId + " .modal-dialog").hasClass("modal-xl")) {
            sOverlaySize = "xl";
        } else {
            sOverlaySize = "lg";
        }
    }

    if (sUrlOveride !== undefined)
        sURL_To_Load = sUrlOveride;

    //sURL_To_Load = sURL_To_Load.replace("site/", "ajax-content/");
    $.ajax({
        type: 'POST',
        url: sURL_To_Load,
        headers: {
            "X-Response-Type": "ajax"
        },
        contentType: sContentType,
        processData: !isMultipart,
        data: sData,
        success: function (xhmlContent, textStatus, XMLHttpRequest) {
            if (XMLHttpRequest.getResponseHeader("Content-Type").search(/text\/html/i) >= 0) {
                handleResponse(sDivId, xhmlContent, textStatus, XMLHttpRequest, bShowOverlay, sOverlaySize, undefined, fnCallback);
            } else if (fnCallback !== undefined) {
                fnCallback(xhmlContent, textStatus, XMLHttpRequest, sDivId, bShowOverlay);

            }
        }
    });

    return false;
    //    }

    //});

    //return false;
};

handleResponse = function (sDivId, xhmlContent, textStatus, XMLHttpRequest, bShowOverlay, sOverlaySize, sOverlayTitle, fnCallback) {
    clearLoadingTimer();

    var sHTMLContent = xhmlContent

    if (bShowOverlay == undefined)
        bShowOverlay = true;

    if (sOverlaySize == undefined)
        sOverlaySize = "lg";

    if (sHTMLContent.indexOf("overlay-title\"") > -1) {
        
        var $xhmlContent = $(sHTMLContent);
        var $overlayTitle = $xhmlContent.find(".overlay-title");
        sOverlayTitle = $overlayTitle.html();
        
        $overlayTitle.remove();        
        sHTMLContent = $('<div>').append($xhmlContent.clone()).html();
    }
    
    if (sHTMLContent.indexOf("\"page-content\"") > -1) {
        var $xhmlContent = $(sHTMLContent);

        sHTMLContent = $xhmlContent.find("#page-content").html();
    }
    
    if (bShowOverlay) {
        displayOverlay(sDivId, sHTMLContent, -1, undefined, sOverlaySize, sOverlayTitle);
    } else {
        $("#" + sDivId).html(sHTMLContent);
    }

    if ((fnCallback !== null) && (fnCallback !== undefined))
        fnCallback();

    setupLinks(sDivId);
    //imagePreview();
};

displayOverlay = function (sDivId, sHTMLContent, iSize, bShowClose, sOverlaySize, sOverlayTitle) {

    if (sOverlaySize === undefined)
        sOverlaySize = "lg";

    if (bShowClose === undefined)
        bShowClose = true;

    if (sOverlayTitle !== undefined) {
        sDivTitleId = sDivId.replace("-content", "-title-holder");
        $("#" + sDivTitleId).html(sOverlayTitle);
    }

    if (sHTMLContent !== "") {
        $("#" + sDivId).html(sHTMLContent);
    }

    var sOverlayDivId = sDivId.replace('-content', '-holder');

    if (bShowClose) {
        $("#" + sOverlayDivId + "-blackout").find(".close-holder").show();
        $("#" + sOverlayDivId + "-blackout").bind("click", function () { return closeOverlay(sOverlayDivId); });

        $("#" + sDivId).find(".btn-back, .btn-close, .back").each(function (idx, obj) {
            $(obj).bind("click", function () { return closeOverlay(sOverlayDivId); });
        });
    } else {
        $("#" + sOverlayDivId + "-blackout").find(".close-holder").hide();
        $("#" + sOverlayDivId + "-blackout").unbind('click');
    }

    //setBlackoutSize(sOverlayDivId);
    //$(window).bind('resize', function () { if (resizeTimer) clearTimeout(resizeTimer); resizeTimer = setTimeout(setBlackoutSize,100);});
    
        $("#" + sOverlayDivId + " .modal-dialog")
            .removeClass("modal-sm")
            .removeClass("modal-md")
            .removeClass("modal-lg")
            .removeClass("modal-xl")
            .addClass("modal-" + sOverlaySize);

    $("#" + sOverlayDivId + "").modal('show');
    //$("#" + sOverlayDivId + "-blackout").fadeIn('slow');
};

setupLinks = function (sDivId, sOverlayDivId, sLinkClass) {
    if ((sDivId.indexOf(".") < 0) && (sDivId.indexOf("#") < 0)) {
        sDivId = "#" + sDivId;
    }

    if ((sOverlayDivId == "") || (sOverlayDivId == undefined)){
        sOverlayDivId = 'overlay-content';
    }

    if ((sLinkClass == "") || (sLinkClass == undefined)) {
        sLinkClass = 'load-overlay';
        sFormClass = 'post-overlay';
    }

    $(sDivId).find("." + sLinkClass + ", ." + sLinkClass + "-sm, ." + sLinkClass + "-md, ." + sLinkClass + "-lg, ." + sLinkClass + "-xl").each(function (idx, obj) {
        

        if (($(this).hasClass(sLinkClass)) ||
            ($(this).hasClass(sLinkClass + "-sm")) ||
            ($(this).hasClass(sLinkClass + "-md")) ||
            ($(this).hasClass(sLinkClass + "-lg")) ||
            ($(this).hasClass(sLinkClass + "-xl"))) {

            var sOverlaySize = "lg";
            var sLinkClass2 = sLinkClass;

            if ($(this).hasClass(sLinkClass + "-sm")) {
                sLinkClass2 += "-sm";
                sOverlaySize = "sm";
            } else if ($(this).hasClass(sLinkClass + "-md")) {
                sLinkClass2 += "-md";
                sOverlaySize = "md";
            } else if ($(this).hasClass(sLinkClass + "-lg")) {
                sLinkClass2 += "-lg";
                sOverlaySize = "lg";
            } else if ($(this).hasClass(sLinkClass + "-xl")) {
                sLinkClass2 += "-xl";
                sOverlaySize = "xl";
            }

            $(this).click(function () {
                var sURL = "";
                var bShowOverlay = true;
                var sClickOverlayDivId = sOverlayDivId;
                var beforeFunction = null;
                var sOverlayTitle = null;
                var callbackFunction = null;

                if($(this).attr("href") !== undefined)
                    sURL = this.href;
                else if ($(this).attr("data-ajax-url") !== undefined) {
                    sURL = $(this).attr("data-ajax-url");
                }

                if ($(this).attr("data-ajaxShowOverlay") != undefined) {
                    bShowOverlay = ($(this).attr("data-ajaxShowOverlay") == "true") ? true : false;
                }
                if ($(this).attr("data-ajax-target") != undefined) {
                    sClickOverlayDivId = $(this).attr("data-ajax-target");
                }

                if ($(this).attr("data-overlay-title") != undefined) {
                    sOverlayTitle = $(this).attr("data-overlay-title");
                }

                if ($(this).attr("data-ajaxCallback") != undefined) {
                    sCallback = $(this).attr("data-ajaxCallback");

                    callbackFunction = eval(sCallback);
                }

                if ($(this).attr("data-ajax-target") != undefined) {
                    sClickOverlayDivId = $(this).attr("data-ajax-target");
                }

                if (beforeFunction != null) {
                    beforeFunction();
                }

                if (sURL !== ""){
                    return loadContent(sURL, sClickOverlayDivId, bShowOverlay, sOverlaySize, callbackFunction, sOverlayTitle);
                }
            });
            
            $(this).removeClass(sLinkClass2).addClass("load-overlay-set");
        }
    });

    $(sDivId).find("." + sFormClass + ", ." + sFormClass + "-sm, ." + sFormClass + "-md, ." + sFormClass + "-lg, ." + sFormClass + "-xl").each(function () {
        //debugger;
        var beforeFunction = null;
        var callbackFunction = null;

        if (($(this).hasClass(sFormClass)) ||
            ($(this).hasClass(sFormClass + "-sm")) ||
            ($(this).hasClass(sFormClass + "-md")) ||
            ($(this).hasClass(sFormClass + "-lg")) ||
            ($(this).hasClass(sFormClass + "-xl"))) {

            var sOverlaySize = "";
            var sFormClass2 = sFormClass;

            if ($(this).hasClass(sFormClass + "-sm")) {
                sFormClass2 += "-sm"
                sOverlaySize = "sm";
            } else if ($(this).hasClass(sFormClass + "-md")) {
                sFormClass2 += "-md"
                sOverlaySize = "md";
            } else if ($(this).hasClass(sFormClass + "-lg")) {
                sFormClass2 += "-lg"
                sOverlaySize = "lg";
            } else if ($(this).hasClass(sFormClass + "-xl")) {
                sFormClass2 = "xl";
                sFormClass += "-xl"
            }         

            $(this).on("submit", function () {

                var bShowOverlay = true;
                var sClickOverlayDivId = sOverlayDivId;
                var beforeFunction = null;
                var callbackFunction = null;

                if ($(this).attr("data-ajaxShowOverlay") != undefined) {
                    bShowOverlay = ($(this).attr("data-ajaxShowOverlay") == "true") ? true : false;
                }

                if ($(this).attr("data-ajaxbefore") != undefined) {
                    sCallBefore = $(this).attr("data-ajaxbefore");

                    beforeFunction = eval(sCallBefore);
                }

                if ($(this).attr("data-ajaxCallback") != undefined) {
                    sCallback = $(this).attr("data-ajaxCallback");

                    callbackFunction = eval(sCallback);
                }

                if ($(this).attr("data-ajax-target") != undefined) {
                    sClickOverlayDivId = $(this).attr("data-ajax-target");
                }

                //var sURL = "";

                //if ($(this).attr("href") != undefined)
                //    sURL = this.href;
                //else if ($(this).attr("data-ajax-url") != undefined) {
                //    sURL = $(this).attr("data-ajax-url")
                //}

                //if (sURL !== "") {
                //debugger;
                if (beforeFunction != null) {
                    beforeFunction();
                }

                return postContent(this, sClickOverlayDivId, bShowOverlay, sOverlaySize, callbackFunction);
                //}
            });

            $(this).removeClass(sFormClass2).addClass("post-overlay-set");
        }
    });

};


var delaySetLoading = null;

clearLoadingTimer = function () {
    if (delaySetLoading)
        clearTimeout(delaySetLoading);
};
setLoading = function (sDivId) {
    clearLoadingTimer();

    //$(sDivId).html("<div class=\"loader-holder\">"
    //            + "  <div class=\"content\">"
    //            + "      <img src=\"" + ROOT + "/images/icons/wait_loader.gif\" width=\"24\" height=\"24\" /><br />"
    //            + "      <p>Loading...</p>"
    //            + "  </div>"
    //            + "</div>");

    $(sDivId).html("<div class=\"display-4 py-5 text-center\">"
        + "    <i class=\"fas fa-sync-alt fa-sync-alt fas text-green\"></i>&nbsp; Loading content..."
                 + "</div>");

    setBlackoutSize();
};

closeOverlay = function (sDivId) {
    if ((sDivId == undefined) || (sDivId == ""))
        sDivId = "overlay-holder";

    if (sDivId.indexOf(".") < 0) {
        sDivId = "#" + sDivId
    }

    $(sDivId).stop().modal("hide"); // fadeOut('fast');
    //(sDivId + "-blackout").stop().fadeOut('fast');

    //$(window).unbind('resize');
    //$(window).unbind('scroll');

    if (resizeTimer)
        clearTimeout(resizeTimer);

    delaySetLoading = setTimeout(function () {
        setLoading(sDivId + " #overlay-content");
    }, 500);

    return false;
};


setBlackoutSize = function (sOverlayDivId) {

    if ((sOverlayDivId == "") || (sOverlayDivId == undefined)) {
        sOverlayDivId = 'overlay-holder';
    }

    $("#" + sOverlayDivId + "-blackout").css("z-index", "998");
    //$("#" + sOverlayDivId).css("z-index", "999");

    var iTop = $(document).scrollTop();

    $("#" + sOverlayDivId + "-blackout").css("height", $(window).height());

    //centerMessageBox($("#" + sOverlayDivId));
}

centerMessageBox = function ($msgBox) {
    console.log("window.height: " + $(window).height());
    console.log("$msgBox.height: " + $msgBox.height());

    var iLeft = (($(window).width() / 2) - ($msgBox.width() / 2));
    var iTop = (($(window).height() / 2) - (($msgBox.height() / 2) + 50)); //+ $(document).scrollTop();

    if (iTop < 10) { iTop = 10; }

    $msgBox.animate({ left: iLeft, top: iTop }, 500);
};

$(document).ready(function () {

    //setBlackoutSize();

    $(window).bind('resize', function () {
        if (resizeTimer)
            clearTimeout(resizeTimer);

        resizeTimer = setTimeout(setBlackoutSize, 100);
    });

    setupLinks("header");
    setupLinks("navigation");
    setupLinks("siteMain");
    setupLinks("footer");
});
